module.exports = __webpack_public_path__ + "11416802b349be5a4b452e813e80dc1e.svg";